import { render, staticRenderFns } from "./edit-producer-brand.vue?vue&type=template&id=c5b41340&"
import script from "./edit-producer-brand.vue?vue&type=script&lang=js&"
export * from "./edit-producer-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports